import type { LifetimeMaterialMultipleLinearParams } from '@igus/tribology-domain';
import { TechnicalEnvironment } from '@igus/tribology-domain';

export const defaultLifeTimeForMaterials: LifetimeMaterialMultipleLinearParams = {
  materialDetails: [],
  oppositeMaterialId: '1',
  environment: TechnicalEnvironment.dry,
  temperature: 23,
  acceptableWear: 0.2,
  activityMinutesPerHour: 60,
  linearStrokeLength: 3,
  linearFrequency: 4,
  load: {
    force: 44,
    area: 10,
  },
  wantExplanation: false,
  unitSystem: 1,
};
